import { gql } from '@apollo/client';

import { CART_TOTALS_FRAGMENT } from '@app/pages/Cart/Cart.queries';

const CART_COUPONS_UPDATE_RESULT_FRAGMENT = gql`
  ${CART_TOTALS_FRAGMENT}

  fragment CartCouponsUpdateResult on Magento2_Cart {
    id
    appliedCoupons {
      code
    }
    prices {
      ...CartTotals
    }
  }
`;

export const APPLY_COUPON_MUTATION = gql`
  ${CART_COUPONS_UPDATE_RESULT_FRAGMENT}

  mutation ApplyCouponMutation($cartId: String!, $couponCode: String!) {
    magento2 {
      applyCouponToCart(input: { cart_id: $cartId, coupon_code: $couponCode }) {
        cart {
          ...CartCouponsUpdateResult
        }
      }
    }
  }
`;

export const REMOVE_COUPON_MUTATION = gql`
  ${CART_COUPONS_UPDATE_RESULT_FRAGMENT}

  mutation RemoveCouponMutation($cartId: String!) {
    magento2 {
      removeCouponFromCart(input: { cart_id: $cartId }) {
        cart {
          ...CartCouponsUpdateResult
        }
      }
    }
  }
`;

export const APPLIED_COUPONS_QUERY = gql`
  ${CART_COUPONS_UPDATE_RESULT_FRAGMENT}

  query AppliedCouponsQuery($cartId: String!) {
    magento2 {
      cart(cart_id: $cartId) {
        ...CartCouponsUpdateResult
      }
    }
  }
`;
